import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { TmaisUserData, TmaisUserResponse } from "../types/tmaisUsers.type";

const useTmaisUser: (id: string) => UseQueryResult<TmaisUserData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<TmaisUserResponse, unknown, TmaisUserData>({
    queryKey: ['tmaisUser', id],
    queryFn: () => privateAxios.get(`/tmais/users/${id}`),
    select: (data) => data?.data?.data
  });
};

export default useTmaisUser;
